import React, { FunctionComponent } from 'react';
import { NextPlanInfo } from '../../../types/companyAccount';
import classnames from 'classnames';
import { STATUS_PATHS, STATUS_VIEWBOX } from '../../../svg/paths/status';

type Props = {
  isPlanOptions: boolean;
  isTrial: boolean;
  nextPlanInfo: NextPlanInfo | null;
  selected?: boolean;
  isCancelPage?: boolean;
  onClickPlanCard?: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isPlanOptions,
  isTrial,
  nextPlanInfo,
  selected,
  isCancelPage,
  onClickPlanCard
}) => {
  const isSuccessPlanOption = isPlanOptions && nextPlanInfo?.planName == '成功報酬プラン'
  const isTrialPlanCard = !isPlanOptions && nextPlanInfo?.planName == 'トライアルプラン'
  const planCardModifier = isCancelPage
    ? 'plan-billing-change__plan-card--cancel'
    : selected
      ? 'plan-billing-change__plan-card--selected'
      : isPlanOptions
        ? 'plan-billing-change__plan-card--options'
        : undefined
  const formatLimitLabel = (label: string, limit?: number | string | null) => (
    limit === undefined || limit === null || limit === 0 || limit === '' ? label : `${label}${limit}${limit === '無制限' ? '' : '通'}`
  );
  return (
    <div className={classnames('plan-billing-change__plan-card', planCardModifier)}
      onClick={onClickPlanCard}
    >
      <div className="plan-billing-change__plan-header">
        <div className="plan-billing-change__plan-title">
          <p>{nextPlanInfo?.planName}</p>
          {nextPlanInfo?.planTerm && (
            <p>{nextPlanInfo?.planTerm}利用</p>
          )}
        </div>
        <div className="plan-billing-change__plan-info">
          {isTrial && isPlanOptions && (
            <div className="plan-billing-change__plan-info-row">
              <p className="plan-billing-change__info-label">再開日</p>
              <p className="plan-billing-change__info-value">{nextPlanInfo?.contractPeriodStart}</p>
            </div>
          )}
          <div className="plan-billing-change__plan-info-row">
            <p className="plan-billing-change__info-label">契約期間</p>
            <div className="plan-billing-change__info-value">
              <p>{nextPlanInfo?.contractPeriodStart}</p>
              <p>~</p>
              {(!isTrial || isPlanOptions) && (
                <p>{nextPlanInfo?.contractPeriodEnd}</p>
              )}
            </div>
          </div>
          {!isPlanOptions && Boolean(nextPlanInfo?.amountBilled) && nextPlanInfo?.amountBilled !== '0' && (
            <div className="plan-billing-change__plan-info-row">
              <p className="plan-billing-change__info-label">請求予定額</p>
              <p className="plan-billing-change__info-value">{nextPlanInfo?.amountBilled}円(税別)</p>
            </div>
          )}
          {isTrial && !isPlanOptions && (
            <div className="plan-billing-change__plan-info-row">
              <p className="plan-billing-change__info-label">更新日</p>
              <p className="plan-billing-change__info-value">{nextPlanInfo?.contractPeriodEnd}</p>
            </div>
          )}
          {!isTrial && (
            isPlanOptions ? (
              <div className="plan-billing-change__plan-info-row">
                <p className="plan-billing-change__info-label">利用料金</p>
                <p className="plan-billing-change__info-value">{nextPlanInfo?.monthlyFee}</p>
              </div>
            ) : (
              <div className="plan-billing-change__plan-info-row">
                <p className="plan-billing-change__info-label">更新日</p>
                <p className="plan-billing-change__info-value">{nextPlanInfo?.contractPeriodEnd}</p>
              </div>
            )
          )}
        </div>
      </div>
      {isPlanOptions && (
        <div className="plan-billing-change__plan-body">
          <div className="plan-billing-change__plan-details">
            <div className="plan-billing-change__price-row">
              <p className="plan-billing-change__price-label">請求確定日</p>
              <p className="plan-billing-change__price-label">{isSuccessPlanOption ? '採用1名ごとに都度確定' : nextPlanInfo?.billingDate}</p>
            </div>
            <div className="plan-billing-change__price-row">
              <p className="plan-billing-change__price-label plan-billing-change__price-label--flexible">請求予定額</p>
              {isSuccessPlanOption ? (
                <div className="plan-billing-change__price-special">
                  <p className="plan-billing-change__price-label">新卒採用:50万円(税別)</p>
                  <p className="plan-billing-change__price-label">新卒採用以外:理論年収の15%(税別)または30万円(税別)のいずれか大きい方</p>
                </div>
              ) : (
                <div className="plan-billing-change__price-value">
                  <p>{nextPlanInfo?.amountBilled}</p>
                  <p>円(税別)</p>
                </div>
              )}
            </div>
            {!isSuccessPlanOption && (
              <div className="plan-billing-change__price-row">
                <p className="plan-billing-change__price-label plan-billing-change__price-label--flexible">支払い期日</p>
                <p className="plan-billing-change__price-label">{nextPlanInfo?.paymentDueDate}</p>
              </div>
            )}
          </div>
        </div>
      )}
      <div className="plan-billing-change__plan-features">
        <div className="plan-billing-change__plan-features-list">
          {((isTrial && !isPlanOptions) || isTrialPlanCard) && (
            <div className="plan-billing-change__feature">
              <div className="plan-billing-change__feature-icon">
                <svg fill="none" preserveAspectRatio="none" viewBox={STATUS_VIEWBOX}>
                  <g>
                    <path
                      d={nextPlanInfo?.canPostRecruitments ? STATUS_PATHS.check : STATUS_PATHS.stop}
                      fill={nextPlanInfo?.canPostRecruitments ? "#007800" : "#FF3B30"}
                    />
                  </g>
                </svg>
              </div>
              <p className="plan-billing-change__feature-text">掲載機能</p>
            </div>
          )}
          <div className="plan-billing-change__feature">
            <div className="plan-billing-change__feature-icon">
              <svg fill="none" preserveAspectRatio="none" viewBox={STATUS_VIEWBOX}>
                <g>
                  <path
                    d={nextPlanInfo?.canUseLikes ? STATUS_PATHS.check : STATUS_PATHS.stop}
                    fill={nextPlanInfo?.canUseLikes ? "#007800" : "#FF3B30"}
                  />
                </g>
              </svg>
            </div>
            <p className="plan-billing-change__feature-text">{formatLimitLabel('気になる', nextPlanInfo?.likeLimit)}</p>
          </div>
          <div className="plan-billing-change__feature">
            <div className="plan-billing-change__feature-icon">
              <svg fill="none" preserveAspectRatio="none" viewBox={STATUS_VIEWBOX}>
                <g>
                  <path
                    d={nextPlanInfo?.canUseScouts ? STATUS_PATHS.check : STATUS_PATHS.stop}
                    fill={nextPlanInfo?.canUseScouts ? "#007800" : "#FF3B30"}
                  />
                </g>
              </svg>
            </div>
            <p className="plan-billing-change__feature-text">{formatLimitLabel('スカウト', nextPlanInfo?.scoutLimit)}</p>
          </div>
          {(isPlanOptions || (!isTrial && !isPlanOptions && !isTrialPlanCard)) && (
            <div className="plan-billing-change__feature">
              <div className="plan-billing-change__feature-icon">
                <svg fill="none" preserveAspectRatio="none" viewBox={STATUS_VIEWBOX}>
                  <g>
                    <path
                      d={nextPlanInfo?.canPostRecruitments ? STATUS_PATHS.check : STATUS_PATHS.stop}
                      fill={nextPlanInfo?.canPostRecruitments ? "#007800" : "#FF3B30"}
                    />
                  </g>
                </svg>
              </div>
              <p className="plan-billing-change__feature-text">上位掲載</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
